<template>
  <div id="mobile-header" class="relative" v-if="settings">
    <ul>
      <li @click="openSidebar()">
        <fai class="icon hamburger" icon="bars"></fai>
      </li>
      <li class="logo-item">
        <Logo width="80px" />
      </li>
      <li class="gap-2">
        <fai id="cart" class="icon text-primary" icon="shopping-bag" @click="openResa()"></fai>
        <fai class="vel-menu" icon="ellipsis-v" @click="toggleMenu()"></fai>
        <!-- <div class="flex items-center mx-2 gap-2 text-white">
          <fai id="cart" class="icon" icon="shopping-bag" @click="openResa()"></fai>
          <osv-account-icon drop-down-position="is-right" />
          <div class="grid place-items-center h-8 w-8">
            <osv-basket-icon />
          </div>
        </div> -->
      </li>
    </ul>
    <div v-if="isMenuVisible" class="hidden-menu">
     
      <osv-account-icon drop-down-position="is-right" />
      <div class="grid place-items-center h-7 w-7">
        <osv-basket-icon />
      </div>
    </div>
    <div class="resa-wrap" v-if="getResa()">
      <a
        v-for="(btn, i) in settings.ctas"
        :key="i"
        target="_blank"
        :href="btn.link.cached_url"
        :style="{ backgroundColor: btn.color ? btn.color.color : '#000' }"
        @click.prevent="openLink(btn.link)"
        >{{ btn.text }}</a
      >
    </div>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  methods: {
    openSidebar() {
      this.$store.commit("SET_SIDEBAR_STATUS", true);
    },
    openResa() {
      this.$store.commit("SET_RESA_STATUS", true);
      this.isMenuVisible = false;
    },
    openLink(link) {
      if (this.$store.getters.resaStatus) {
        this.$store.commit("SET_RESA_STATUS", false);
      } else {
        this.$store.commit("SET_RESA_STATUS", true);
      }
      this.getStoryblokLink(link);
    },
    getResa() {
      return this.$store.getters.resaStatus;
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
      this.$store.commit("SET_RESA_STATUS", !this.isMenuVisible);
    }
  },
  computed: {
    getStore(park) {
      return this.$store.getters.stores;
    },
    settings() {
      return this.$store.getters.settings;
    }
  },
  data() {
    return {
      isActive: false,
      isMenuVisible: false
    };
  }
};
</script>

<style lang="scss">
#mobile-header {
  position: relative;
  width: 100%;
  z-index: 333;
  background-color: $primary;
  .hidden-menu {
    position:absolute;
    top:100%;
    right:0;
    @apply bg-primary px-4 py-5 gap-4 text-white;
    display:flex;
    align-items: flex-start;
    flex-direction: column;
    svg {
      color:$primary !important;
    }
  }
  > ul {
    width: 100%;
    display: flex;
    padding: 0;
    margin: 0;
    justify-content: space-around;
    padding: 15px 20px;
    > li {
      display: flex;
      align-items: center;
      justify-content: center;
      .vel-menu {
        font-size: 23px;
        color: #fff;
        cursor: pointer;
      }
      &:first-child {
        justify-content: flex-start;
      }
      &:last-child {
        justify-content: flex-end;
      }
      .icon {
        font-size: 25px;
        color: #fff;
        cursor: pointer;
      }
      &.logo-item {
        flex: 1;
        text-align: center;
        margin: auto;
        img {
          margin: auto;
        }
      }
    }
  }
  .resa-wrap {
    position: absolute;
    top: 75px;
    right: 0;
    background-color: $primary;

    display: flex;
    flex-direction: column;
    color: white;
    font-family: "Luckiest Guy", cursive;

    a {
      padding: 1em;
      text-align: center;
      text-decoration: none;
      &:visited {
        color: white;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  #mobile-header {
    > ul {
      > li {
        .icon {
          font-size: 20px;
        }
      }
    }
  }
}

@media screen and (max-width: $desktop) {
  #mobile-header {
    > ul {
      > li {
        width: 25%;
        .icon {
          font-size: 45px;
          padding: 10px;
        }
      }
    }
  }
}
</style>
